export type ReportBadgeColor =
  | "bg-gray-800"
  | "bg-green-500"
  | "bg-blue-500"
  | "bg-red-500"
  | "bg-purple-500"
  | "bg-amber-500"
  | "bg-cyan-500"
  | "bg-text-secondary";

export const toPercentBadge = (value: number, total: number) => {
  if (!total) return "0.0%";
  return `${((value / total) * 100).toFixed(1)}%`;
};

/** Signed day-over-day change, e.g. `+12.3%` / `-4.1%` / `0%`, colored by direction. */
export const toTrendBadge = (
  percent: number,
): { badgeLabel: string; badgeColor: ReportBadgeColor } => ({
  badgeLabel: `${percent > 0 ? "+" : ""}${percent}%`,
  badgeColor: percent < 0 ? "bg-red-500" : percent > 0 ? "bg-green-500" : "bg-gray-800",
});

export const RECYCLING_POINT_BADGE_COLORS: ReportBadgeColor[] = [
  "bg-green-500",
  "bg-red-500",
  "bg-purple-500",
  "bg-blue-500",
  "bg-amber-500",
  "bg-cyan-500",
];
